const blog = {
  getAllBlogPosts: async function() {
    return await this.$store.getters
      .fetcher({
        query: `{ blogPosts {
          Blog_Post_Id
          Title
          Summary
          Release_Date
          Thumbnail_Picture
          Approved
          Header_Picture
          Post
          Author{
            User_Id
            First_Name
            Last_Name
          }
          Categories{
            Category_Id
            Name
          }
        }
      }`
      })
      .then(r => {
        return r.data.blogPosts;
      });
  },

  getBlogPost: async function(blogPostId) {
    return await this.$store.getters
      .fetcher({
        query:
          `{ blogPost(id: ` +
          parseInt(blogPostId) +
          `) {
        Blog_Post_Id
        Title
        Summary
        Release_Date
        Thumbnail_Picture
        Header_Picture
        Post
        Author{
          User_Id
          First_Name
          Last_Name
        }
        Categories{
          Category_Id
          Name
        }
      }
    }`
      })
      .then(r => {
        return r.data.blogPost;
      });
  },

  getReleasedBlogPosts: async function() {
    return await this.$store.getters
      .fetcher({
        query: `{ releasedBlogPosts {
          Blog_Post_Id
          Title
          Summary
          Release_Date
          Thumbnail_Picture
          Author{
            User_Id
            First_Name
            Last_Name
          }
          Categories{
            Category_Id
            Name
          }
        }
      }`
      })
      .then(r => {
        return r.data.releasedBlogPosts;
      });
  },

  createPost: async function(postToCreate) {
    const query = `mutation($title: String!, $summary: String!, $post: String!, $releaseDate: DateTime!, $headerPicture: String!, $thumbnailPicture: String!, $authorId: Int!){ 
      CreateBlogPost(title: $title, summary: $summary, post: $post, releaseDate: $releaseDate, headerPicture: $headerPicture, thumbnailPicture: $thumbnailPicture, authorId: $authorId){
      Blog_Post_Id
    }}`;
    const variables = {
      title: postToCreate.Title,
      summary: postToCreate.Summary,
      post: postToCreate.Post,
      releaseDate: postToCreate.Release_Date,
      headerPicture: postToCreate.Header_Picture,
      thumbnailPicture: postToCreate.Thumbnail_Picture,
      authorId: parseInt(postToCreate.Author.User_Id)
    };
    return await this.$store.getters.fetcher({ query, variables }).then(r => {
      postToCreate.Blog_Post_Id = r.data.CreateBlogPost.Blog_Post_Id;
      return postToCreate;
    });
  },

  updatePost: async function(postToUpdate) {
    const query = `mutation($blogPostId: Int!, $title: String!, $summary: String!, $post: String!, $releaseDate: DateTime!, $headerPicture: String!, $thumbnailPicture: String!, $authorId: Int!){ 
      UpdateBlogPost(blogPostId: $blogPostId, title: $title, summary: $summary, post: $post, releaseDate: $releaseDate, headerPicture: $headerPicture, thumbnailPicture: $thumbnailPicture, authorId: $authorId){
      Blog_Post_Id
    }}`;
    const variables = {
      blogPostId: parseInt(postToUpdate.Blog_Post_Id),
      title: postToUpdate.Title,
      summary: postToUpdate.Summary,
      post: postToUpdate.Post,
      releaseDate: postToUpdate.Release_Date,
      headerPicture: postToUpdate.Header_Picture,
      thumbnailPicture: postToUpdate.Thumbnail_Picture,
      authorId: parseInt(postToUpdate.Author.User_Id)
    };
    return await this.$store.getters.fetcher({ query, variables }).then(() => {
      return postToUpdate;
    });
  },

  createPostCategories: async function(postId, categories) {
    for (let i = 0; i < categories.length; i++) {
      categories[i];
      var query = `mutation($blogPostId: Int!, $categoryId: Int!){ 
        CreateBlogCategory(blogPostId: $blogPostId, categoryId: $categoryId){
        Blog_Category_Id
      }}`;
      var variables = {
        blogPostId: parseInt(postId),
        categoryId: parseInt(categories[i].Category_Id)
      };
      await this.$store.getters.fetcher({ query, variables });
    }
    return;
  },

  deletePostCategories: async function(postId, categories) {
    for (let i = 0; i < categories.length; i++) {
      categories[i];
      var query = `mutation($blogPostId: Int!, $categoryId: Int!){ 
        DeleteBlogCategory(blogPostId: $blogPostId, categoryId: $categoryId)
      }`;
      var variables = {
        blogPostId: parseInt(postId),
        categoryId: parseInt(categories[i].Category_Id)
      };
      await this.$store.getters.fetcher({ query, variables });
    }
    return;
  },

  approveBlogPost: async function(postId) {
    var query = `mutation($blogPostId: Int!){ 
      ApproveBlogPost(blogPostId: $blogPostId){
        Blog_Post_Id
      }
    }`;
    var variables = {
      blogPostId: parseInt(postId)
    };
    return await this.$store.getters.fetcher({ query, variables }).then(r => r.data.ApproveBlogPost)
  }
};

export { blog };
